import { render, staticRenderFns } from "./CrawlerForm.vue?vue&type=template&id=423d929b&scoped=true"
import script from "./CrawlerForm.vue?vue&type=script&lang=js"
export * from "./CrawlerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423d929b",
  null
  
)

export default component.exports